import { LocalData, StorageType } from '../types';

// It should never have happened
if (!window) {
  console.error('Window Local Storage Missing.  No data will be stored locally.');
}

const KEY = 'ZAMEL_APP_DATA_STORAGE';

const emptyData: StorageType = {
  displayedMessagesList: [],
  theme: null,
  wasIntroduced: false,
  isListView: false,
  meterAdvancedParameters: false,
  isChannelsListView: false,
  lastActiveGroupId: null,
  lastActiveTabInChannelList: null,
  lastActiveTabInDeviceList: null,
  lastActiveActionTab: null,
  bluetoothNetwork: null,
  vibration: true,
  remindNative: null,
  remindEvaluate: null,
  updateDevicesMemory: {},
  localData: {
    installationList: [],
  },
  meterParameters: [],
  dashboardMeterExcludedChannels: [],
};

let data: StorageType = { ...emptyData };

const dataString = window.localStorage.getItem(KEY);

if (dataString) {
  try {
    const parsedData: StorageType = JSON.parse(dataString);
    if (parsedData) {
      data = parsedData;
    }
  } catch {
    console.error(`LocalStorage value of key: "${KEY}" is not a valid JSON.`);
    // Temporary option of clearing cache on error
    window.localStorage.removeItem(KEY);
    data = emptyData;
  }
}

export const get = (): StorageType => {
  return data;
};

export const set = (newData: StorageType) => {
  data = newData;
  window.localStorage.setItem(KEY, JSON.stringify(data));
};

export const getItem = <Key extends keyof StorageType>(key: Key): StorageType[Key] => {
  return data[key];
};

export const setItem = <Key extends keyof StorageType>(key: Key, value: StorageType[Key]) => {
  data[key] = value;
  window.localStorage.setItem(KEY, JSON.stringify(data));
};

export const clear = () => {
  window.localStorage.removeItem(KEY);
  data = emptyData;
};

export const setLocalItem = <Key extends keyof LocalData>(key: Key, value: LocalData[Key]) => {
  const oldData = window.localStorage.getItem(KEY);

  if (oldData) {
    const oldDataParsed: StorageType = JSON.parse(oldData);
    if (!oldDataParsed.localData) {
      oldDataParsed.localData = emptyData.localData;
    } else {
      oldDataParsed.localData = {
        ...oldDataParsed.localData,
        [key]: value,
        [key]: value,
      };
    }
    window.localStorage.setItem(KEY, JSON.stringify(oldDataParsed));
  }
};

export const getLocalItem = <Key extends keyof LocalData>(key: Key): LocalData[Key] | null => {
  const data = window.localStorage.getItem(KEY);
  if (data) {
    const dataParsed: StorageType = JSON.parse(data);
    if (dataParsed.localData) return dataParsed.localData[key];
  }

  return null;
};
